import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

// import SearchBar from '../../Core/SearchBar';
import FAQSearch from '../FAQSearch';

export const Wrapper = styled.div`
  text-align: center;
  margin-bottom: 40px;

  h2,
  h3 {
    margin-bottom: 20px;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 70px;
  }
`;

export const Controls = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: 50px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
  }
`;

export const Search = styled(FAQSearch)`
  max-width: 626px;
  margin-bottom: 10px;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-bottom: 0;
  }

  input[type='search'] {
    &::placeholder {
      font-size: 16px;
      font-weight: ${themeGet('fontWeights.normal')};
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
    }
  }
`;
